import React, { useState, useEffect } from "react";
import { sbGetSetting, sbSetSetting } from "../utils/supabaseClient";
import "../styles/ListTab.css";

const PromptListTab = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  useEffect(() => {
    loadPrompts();
  }, []);

  const loadPrompts = async () => {
    try {
      setLoading(true);
      const data = await sbGetSetting("origamic-prompts");
      const sorted = Array.isArray(data)
        ? [...data].sort((a, b) => new Date(b.addedAt) - new Date(a.addedAt))
        : [];
      setPrompts(sorted);
    } catch (err) {
      console.error("Error loading prompts:", err);
      alert("Failed to load prompts");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this prompt?")) return;

    try {
      const updated = prompts.filter((p) => p.id !== id);
      await sbSetSetting("origamic-prompts", updated);
      setPrompts(updated);
      alert("Prompt deleted successfully!");
    } catch (err) {
      console.error("Error deleting prompt:", err);
      alert("Failed to delete prompt");
    }
  };

  const handleEdit = (prompt) => {
    setEditingId(prompt.id);
    setEditFormData({ ...prompt });
  };

  const handleSaveEdit = async () => {
    try {
      const updated = prompts.map((p) =>
        p.id === editingId ? editFormData : p
      );
      await sbSetSetting("origamic-prompts", updated);
      setPrompts(updated);
      setEditingId(null);
      alert("Prompt updated successfully!");
    } catch (err) {
      console.error("Error saving prompt:", err);
      alert("Failed to save prompt");
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditFormData({});
  };

  if (loading) return <div className="loading">Loading prompts...</div>;

  if (prompts.length === 0)
    return <div className="empty-state">No prompts found. Create one first!</div>;

  return (
    <div className="list-container">
      <h2>All Prompts ({prompts.length})</h2>

      {editingId ? (
        // Edit Form
        <div className="edit-form">
          <h3>Edit Prompt</h3>
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              value={editFormData.title || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, title: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <input
              type="text"
              value={editFormData.cat || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, cat: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Content</label>
            <textarea
              value={editFormData.text || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, text: e.target.value })
              }
              rows="8"
            />
          </div>
          <div className="form-actions">
            <button className="btn-save" onClick={handleSaveEdit}>
              💾 Save Changes
            </button>
            <button className="btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        // Prompts List
        <div className="items-grid">
          {prompts.map((prompt) => (
            <div key={prompt.id} className="item-card">
              <div className="item-content">
                <h4>{prompt.title}</h4>
                {prompt.cat && <p className="item-meta">Category: {prompt.cat}</p>}
                <p className="item-preview">{prompt.text.substring(0, 100)}...</p>
              </div>
              <div className="item-actions">
                <button
                  className="btn-edit"
                  onClick={() => handleEdit(prompt)}
                >
                  ✏️
                </button>
                <button
                  className="btn-delete"
                  onClick={() => handleDelete(prompt.id)}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PromptListTab;
